/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from "@";
import type { CardDesignFormValues } from "../types";

interface UseCertificateImageDesignReturn {
  saveCertificateImageDesign: (designs: CardDesignFormValues[]) => void;
  showCertificateImageDesigner: () => void;
  isShowCertificateImageDesigner: boolean;
  certificateImageDesign: CardDesignFormValues[];
  setIsShowCertificateImageDesigner: React.Dispatch<React.SetStateAction<boolean>>;
}

// Hook for managing Certificate card design
export const useCertificateImageDesign = (
  getValues: any,
  setValue: any,
): UseCertificateImageDesignReturn => {
  const [certificateImageDesign, setCertificateImageDesign] = useState<CardDesignFormValues[]>([]);
  const [isShowCertificateImageDesigner, setIsShowCertificateImageDesigner] =
    useState(false);

  // Save the Certificate Image card design
  const saveCertificateImageDesign = useCallback(
    (designs: CardDesignFormValues[]) => {
      setValue("endowmentCertificateDesign", designs);
      setIsShowCertificateImageDesigner(false);
      document.body.style.overflow = "auto";
    },
    [setValue, setIsShowCertificateImageDesigner],
  );

  // Show the Certificate Image designer
  const showCertificateImageDesigner = useCallback(() => {
    const design = getValues("endowmentCertificateDesign") as CardDesignFormValues[];
    setCertificateImageDesign(design);
    setIsShowCertificateImageDesigner(true);
    document.body.style.overflow = "hidden";
  }, [getValues, setIsShowCertificateImageDesigner, setCertificateImageDesign]);

  return {
    saveCertificateImageDesign,
    showCertificateImageDesigner,
    isShowCertificateImageDesigner,
    certificateImageDesign,
    setIsShowCertificateImageDesigner,
  };
};
